import React from 'react';

export enum TwilioStatus {
  OK = 'OK',
  GEO_BLOCKED = 'GEO_BLOCKED',
}

interface TwilioOkContentProps {}

const TwilioOkContent: React.FC<TwilioOkContentProps> = () => (
  <>
    <p className="mb-2">
      The user's phone number does not seem to be blocked by Twilio's
      Geo-permissions.
    </p>
    <p>
      <strong className="font-medium">HOWEVER:</strong> Twilio does not provide
      an API for checking if a user is blocked due to its fraud detection tool{' '}
      <strong className="font-medium">FraudGuard</strong> which means that even
      if we do not block the country that this user's phone number is from, they
      might still be blocked due to FraudGuard.
    </p>
  </>
);

interface TwilioGeoBlockedContentProps {}

const TwilioGeoBlockedContent: React.FC<TwilioGeoBlockedContentProps> = () => (
  <p>
    This action can be used to add the user's phone number to Twilio's safelist;
    As a result, the user will be able to receive messages from Twilio even if
    we block the country that their phone number is from.
  </p>
);

export const TwilioStateContent: React.FC<{ status: TwilioStatus }> = ({
  status,
}) => {
  return status === TwilioStatus.OK ? (
    <TwilioOkContent />
  ) : (
    <TwilioGeoBlockedContent />
  );
};
